// extracted by extract-css-chunks-webpack-plugin
module.exports = {"adregion":"adregion-2DY8Sxmv"};